export default {
    /**
     * Return true if user has permission given
     * @param  {String} permission
     * @return {Boolean}
     */
    hasPermissionTo(permission) {
        this.throwIfParamNotSet(permission, 'Undefined permission parameter');

        if (this.isSuperAdmin()) return true;

        return this.userPermissions.indexOf(permission) >= 0;
    },

    /**
     * Return true if user has any permissions given
     * @param  {Array}  permissions
     * @return {Boolean}
     */
    hasAnyPermissions(permissions) {
        this.throwIfParamNotArray(permissions);

        if (this.isSuperAdmin()) return true;

        for (let i = 0; i < permissions.length; i++) {
            if (this.hasPermissionTo(permissions[i])) {
                return true;
            }
        }

        return false;
    },

    /**
     * @param  {String} permission
     * @return {Boolean}
     */
    can(permission) {
        return this.hasPermissionTo(permission);
    },

    /**
     * @param  {String}  role
     * @return {Boolean}
     */
    hasRole(role) {
        this.throwIfParamNotSet(role, 'Undefined role parameter');

        if (this.isSuperAdmin()) return true;

        return this.userRoles.indexOf(role) >= 0;
    },

    /**
     * Return true if user has any permissions given
     * @param  {Array}  permissions
     * @return {Boolean}
     */
    hasAnyRoles(roles) {
        this.throwIfParamNotArray(roles);

        if (this.isSuperAdmin()) return true;

        for (let i = 0; i < roles.length; i++) {
            if (this.hasRole(roles[i])) {
                return true;
            }
        }

        return false;
    },

    /**
     * @param  {String|Integer} outlet
     * @return {Boolean}
     */
    canAccessOutlet(outlet) {
        this.throwIfParamNotSet(outlet, 'Undefined outlet parameter');

        if (this.isSuperAdmin()) return true;

        return this.userOutlets.indexOf(outlet) >= 0;
    },

    /**
     * [canAccessAnyOutlet description]
     * @param  {Array} outlets
     * @return {Boolean}
     */
    canAccessAnyOutlet(outlets) {
        this.throwIfParamNotArray(permissions);

        if (this.isSuperAdmin()) return true;

        for (let i = 0; i < permissions.length; i++) {
            if (this.hasPermissionTo(permissions[i])) {
                return true;
            }
        }

        return false;
    },

    /**
     * @return {Boolean}
     */
    isSuperAdmin() {
        return this.userRoles.indexOf(this.superAdminRole) >= 0;
    },

    throwIfParamNotSet(value, msg = 'Parameter not set') {
        if (value == null || typeof value !== 'undefined') {
            return new ReferenceError(msg);
        }
    },

    throwIfParamNotArray(value) {
        if (!(value instanceof Array)) {
            return new TypeError('Expected params type of Array');
        }
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/auth/lib/mixins/methods.js